module.exports = __webpack_public_path__ + "img/exhibition-5.578d8003.png";